import {
  Input,
  Component,
  HostBinding,
  ChangeDetectionStrategy,
  output,
  input,
} from '@angular/core';
import { ChartDto, DashboardDto, DashboardFavoritesDto } from '@shared/dto';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FavoriteListComponent } from '../favorite-list/favorite-list.component';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgbTooltip, FavoriteListComponent],
})
export class CardComponent {
  readonly heading = input<string>();

  readonly chart = input<ChartDto>();

  @Input() description: string;

  readonly favorites = input<DashboardFavoritesDto>();

  readonly dashboards = input<DashboardDto[]>([]);

  readonly showFavorites = input(true);

  readonly addChartToDashboard = output<DashboardDto>();

  readonly removeChartFromDashboard = output<DashboardDto>();

  readonly createDashboard = output<string>();

  @HostBinding('class.card') card = true;

  onAddChartToDashboard(dashboard: DashboardDto) {
    this.addChartToDashboard.emit(dashboard);
  }

  onRemoveChartFromDashboard(dashboard: DashboardDto) {
    this.removeChartFromDashboard.emit(dashboard);
  }

  onCreateDashboard(name: string) {
    this.createDashboard.emit(name);
  }
}
